import { render, staticRenderFns } from "./Treasuries.vue?vue&type=template&id=1ee41c73&scoped=true&"
import script from "./Treasuries.vue?vue&type=script&lang=js&"
export * from "./Treasuries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee41c73",
  null
  
)

export default component.exports